export enum MyDiaryStepsEnum {
    inicio = 'inicio',
    historico = 'historico',
    sintomas = 'sintomas',
    loading = 'loading'
}